export enum currencies {
  GBP = '£',
  EUR = '€',
}